/**
 * Kennzeichnet das Dokument als «JavaScript aktiv», damit CSS zwischen der
 * Darstellung mit und ohne JavaScript unterscheiden kann (docs/ux-design.md, 4.2).
 */
export function markiereJavaScriptAktiv(wurzel: HTMLElement): void {
  wurzel.classList.remove('kein-js');
  wurzel.classList.add('js');
}
